import { useMutation } from "@apollo/client";
import { BULK_EDIT_ASSETS } from "../../graphql/mutations/assets/assets.mutations";

const useBulkEditAssets = () => {
  const [bulkEditAssetsMutation, { loading, error }] =
    useMutation(BULK_EDIT_ASSETS);

  const bulkEditAssets = async (assets) => {
    try {
      const res = await bulkEditAssetsMutation({ variables: { assets } });
      return res?.data?.bulkEditAssets ?? { updated: [], failed: [] };
    } catch (err) {
      console.error(`Error updating assets: ${err?.message}`);
      throw err;
    }
  };

  return { bulkEditAssets, loading, error };
};

export default useBulkEditAssets;
